import { SynopticLogoCompactIcon } from '@synoptic/ui-kit/icons/react/synoptic-logo-compact.js';
import { floatingWatermarkPanel } from './route.css';

export const GraphWatermark = () => {
  return (
    <div className={floatingWatermarkPanel}>
      {/* <SynopticLogoIcon width={128} height={35} /> */}
      <SynopticLogoCompactIcon height={20} />
      synoptic.com/ct
    </div>
  );
};
